/*
 * Shopify Common JS
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {}
}

Shopify.bind =
  (fn, scope) =>
  (...args) =>
    fn.apply(scope, args)

Shopify.setSelectorByValue = (selector, value) => {
  const selectorOptions = selector.querySelectorAll('sl-option')
  for (let i = 0, count = selectorOptions.length; i < count; i++) {
    const option = [...selectorOptions][i]
    if (value === option.value || value === option.innerHTML) {
      selector.value = option.value
    }
  }
}

Shopify.addListener = (target, eventName, callback) => {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback)
}

Shopify.postLink = (path, options = {}) => {
  const method = options.method || 'post'
  const params = options.parameters || {}

  const form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const hiddenField = document.createElement('input')
      hiddenField.setAttribute('type', 'hidden')
      hiddenField.setAttribute('name', key)
      hiddenField.setAttribute('value', params[key])
      form.appendChild(hiddenField)
    }
  }

  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  )

  if (!this.countryEl || !this.provinceEl) {
    return
  }

  Shopify.addListener(
    this.countryEl,
    'sl-change',
    Shopify.bind(this.countryHandler, this),
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    const value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.querySelectorAll('sl-option').length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function () {
    const opt = [...this.countryEl.querySelectorAll('sl-option')].filter(
      (option) => {
        return option.value === this.countryEl.value
      },
    )[0]
    if (!opt) return
    const raw = opt.getAttribute('data-provinces')
    const provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const opt = document.createElement('sl-option')
        opt.value = provinces[i][0].replace(/ /g, '_')
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: (selector) => {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: (selector, values) => {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('sl-option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

/**
 * Attempts to re-render found DOMNodes in the current
 * mounted HTML Document.
 *
 * @param {String} selector
 * @returns Null
 */
export const reRenderShopifySections = (
  response,
  selector = '[data-rerender]',
) => {
  for (const key of Object.keys(response.sections)) {
    const updatedNodes = new DOMParser()
      .parseFromString(response.sections[key], 'text/html')
      .querySelectorAll(selector)

    const currentNodes = document
      .querySelector(`[id^="shopify-section-"][id*="${key}"]`)
      .querySelectorAll(selector)

    for (let i = 0; i < currentNodes.length; i++) {
      currentNodes[i].replaceWith(updatedNodes[i])
    }
  }
}

/**
 * Generates a URL that is suitable for the Shopify
 * image CDN. Adds the current image size suffix.
 *
 * @param {*} src
 * @param {*} size
 */
export const getImageWithSize = (src = '', size = 1000) => {
  return `${src}`.replace(/([.](?:jpe?g|png))/, `_${size}x$1`)
}

/**
 * Used by components like the product card to select
 * the current product image based on the active color.
 * If there is no active color, a fallback image
 * should be returned if it is defined.
 *
 * @param {*} images
 * @param {*} featured
 * @param {*} fallback
 * @param {*} color
 */
export const getProductImage = (
  images,
  featured = false,
  fallback = false,
  name = '',
  value = '',
) => {
  const key = `${name}-${(value || '').replace(/[/ ]/g, '-')}`.toLowerCase()
  const image = (images || []).find(({ src }) => {
    return ~src.indexOf(key) && ~src.indexOf(featured ? 'pos-1' : 'pos-2')
  })
  if (!image) {
    return getImageWithSize(fallback, 600)
  }
  return getImageWithSize(image, featured ? 1200 : 600)
}

/**
 * Decode Storefront Product ID, this is used
 * with Storefront API
 *
 * @param {*} src
 * @param {*} size
 */
export const decodeIDproduct = (id) => {
  return decodeURIComponent(escape(window.atob(id))).split(
    'gid://shopify/Product/',
  )[1]
}

/**
 * Encode from numerical to Storefront Product ID, this is used
 * with Storefront API
 *
 * @param {*} src
 * @param {*} size
 */
export const encodeIDproduct = (id) => {
  return window.btoa(`gid://shopify/Product/${id}`)
}

/**
 * Decode Storefront Product Variant ID, this is used
 * with Storefront API
 *
 * @param {*} src
 * @param {*} size
 */
export const decodeIDproductVariant = (id) => {
  return decodeURIComponent(escape(window.atob(id))).split(
    'gid://shopify/ProductVariant/',
  )[1]
}
